import { render, staticRenderFns } from "./SuccessSended.vue?vue&type=template&id=7df4a0ba&scoped=true"
import script from "./SuccessSended.vue?vue&type=script&lang=js"
export * from "./SuccessSended.vue?vue&type=script&lang=js"
import style0 from "./SuccessSended.vue?vue&type=style&index=0&id=7df4a0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4a0ba",
  null
  
)

export default component.exports